export const CATEGORIES = [
  { key: "alle", label: "Alle Arbeiten" },
  { key: "events", label: "Events" },
  { key: "hochzeit", label: "Hochzeiten" },
  { key: "unternehmen", label: "Unternehmen" },
  { key: "landschaft", label: "Landschaft" },
  { key: "tiere", label: "Tiere" },
  { key: "automotive", label: "Automotive" },
];

export const CATEGORY_LABELS = Object.fromEntries(CATEGORIES.map((c) => [c.key, c.label]));

export const BOOKING_TYPES = [
  { key: "hochzeit", label: "Hochzeiten" },
  { key: "paare", label: "Paarshooting" },
  { key: "familie", label: "Familie & Kinder" },
  { key: "babybauch", label: "Babybauch" },
  { key: "events", label: "Events" },
  { key: "unternehmen", label: "Unternehmen / Business" },
  { key: "tiere", label: "Tiere" },
  { key: "automotive", label: "Automotive" },
  { key: "landschaft", label: "Landschaft" },
  { key: "sonstiges", label: "Sonstiges" },
];

export const TYPE_LABELS = Object.fromEntries([...CATEGORIES, ...BOOKING_TYPES].map((t) => [t.key, t.label]));

export const TIME_SLOTS = [
  { key: "flexibel", label: "Flexibel / egal" },
  { key: "vormittag", label: "Vormittag (9–12 Uhr)" },
  { key: "mittag", label: "Mittag (12–15 Uhr)" },
  { key: "nachmittag", label: "Nachmittag (15–18 Uhr)" },
  { key: "golden_hour", label: "Golden Hour (Sonnenuntergang)" },
  { key: "ganztaegig", label: "Ganztägig" },
];

export const TIME_SLOT_LABELS = Object.fromEntries(TIME_SLOTS.map((t) => [t.key, t.label]));

export const MARQUEE_ITEMS = [
  "Events",
  "Hochzeiten",
  "Unternehmen",
  "Landschaft",
  "Tiere",
  "Automotive",
  "Momente · Natürlich · Echt",
];

export const CHAPTERS = [
  {
    nr: "01",
    title: "Momente",
    text: "Das perfekte Foto ist kein Zufall. Es ist der eine Moment, in dem alles zusammenkommt — Licht, Gefühl, Timing. Genau diesen Moment jage ich, bei jedem Shooting.",
  },
  {
    nr: "02",
    title: "Natürlich",
    text: "Keine steifen Posen, kein Zwang. Die schönsten Bilder entstehen, wenn ihr einfach ihr selbst seid — ich halte mich im Hintergrund und fange ein, was wirklich passiert.",
  },
  {
    nr: "03",
    title: "Echt",
    text: "Echte Emotionen statt Filter-Perfektion. Was ihr auf meinen Bildern seht, ist wirklich passiert — und es wird sich auch in zwanzig Jahren noch so anfühlen.",
  },
];

export const PACKAGES = [
  {
    nr: "01",
    name: "Events & Feiern",
    tagline: "Geburtstage, Firmenfeiern & mehr",
    price: "ab 160 €",
    features: [
      "Bis zu 4 Stunden Reportage-Begleitung",
      "150+ bearbeitete Bilder in voller Auflösung",
      "Private Online-Galerie zum Teilen",
      "Express-Lieferung innerhalb von 72 Stunden",
    ],
    featured: false,
  },
  {
    nr: "02",
    name: "Eure Hochzeit",
    tagline: "Der schönste Tag — für immer",
    price: "ab 950 €",
    features: [
      "Bis zu 10 Stunden Begleitung",
      "500+ liebevoll bearbeitete Bilder",
      "Kennenlern-Shooting inklusive",
      "Hochwertiges Fotobuch (30 × 30 cm)",
      "Sneak-Preview mit 20 Bildern nach 48 Stunden",
    ],
    featured: true,
  },
  {
    nr: "03",
    name: "Business & Automotive",
    tagline: "Unternehmen, Tiere & Fahrzeuge",
    price: "auf Anfrage",
    features: [
      "Business-Portraits & Teamfotos",
      "Automotive- und Detailshootings",
      "Tierportraits mit Geduld & Herz",
      "Nutzungsrechte für Web & Print inklusive",
    ],
    featured: false,
  },
];

export const HERO_IMAGE = "/assets/leno-portrait.jpg";

export const PROFILE_IMAGE = "/assets/eric-portrait.jpg";

export const INSTAGRAM_URL = "https://instagram.com/leno_fotos779";
export const CONTACT_EMAIL = "eric779fotos@gmail.com";

const FILES_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/files/leno-fotografie/uploads/6ae5dd93-a068-495d-a7df-640bad496df5`;

export const HERO_IMAGES = [
  "/assets/leno-portrait.jpg",
  "/assets/eric-portrait.jpg",
  `${FILES_BASE}/d3a7fed5-8fb3-4a26-b15c-41f6a086ed09.jpeg`,
  `${FILES_BASE}/d7d98907-29ba-405f-96de-0bd251a114cd.jpeg`,
  `${FILES_BASE}/72ee305c-3711-4a55-be45-976f7799556b.jpeg`,
  `${FILES_BASE}/1670b8f4-c589-4af9-86f1-89c2db258c4f.jpg`,
];
